import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from "@/i18n";

Vue.use(VueRouter);
Vue.component('Header', ()=>import("../components/header/Header"));
Vue.component('subHeader', ()=>import("../components/subHeader/subHeader"));
Vue.component('foot', ()=>import("../components/footer/foot"));
Vue.component('homeSlider', ()=>import("../views/Home/components/slider"));
Vue.component('subSlider', ()=>import("../components/subSlider/subSlider"));
Vue.component('loading', ()=>import("../components/loading/loading"));

const routes = [
    {
        path: '/register',
        name: 'register',
        component: () => import("../views/auth/register"),
        meta: {
            title: 'ثبت نام',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'ثبت نام',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import("../views/auth/login"),
        meta: {
            title: 'ورود',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'ورود',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import("../views/profile"),
        meta: {
            title: 'پروفایل',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'پروفایل',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/',
        name: 'Home',
        component: () => import("../views/Home/Home.vue"),
        meta: {
            title: 'صفحه اصلی',
            
        }
    },
    {
        path: '/about-ardakan',
        name: 'aboutArdakan',
        component: () => import("../views/about/aboutArdakan/aboutArdakan"),
        meta: {
            title: 'درباره شیشه اردکان',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'معرفی مجموعه',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/export',
        name: 'export',
        component: () => import("../views/about/export/export"),
        meta: {
            title: 'صادرات',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'صادرات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/certificates',
        name: 'certificates',
        component: () => import("../views/about/certificates/certificates"),
        meta: {
            title: 'گواهینامه ها و افتخارات',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گواهینامه ها و افتخارات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },

    {
        path: '/tour',
        name: 'tour',
        component: () => import("../views/about/tour/tour"),
        meta: {
            title: 'تور',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'تور',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/news',
        name: 'News',
        component: () => import("../views/News/News"),
        meta: {
            title: 'مقالات',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مقالات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/catalogue',
        name: 'Catalogue',
        component: () => import("../views/News/Catalogue"),
        meta: {
            title: 'کاتالوگ',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'کاتالوگ',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/projects',
        name: 'projects',
        component: () => import("../views/News/Projects"),
        meta: {
            title: 'پروژه ها',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'پروژه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/gallery',
        name: 'gallery',
        component: () => import("../views/News/Gallery"),
        meta: {
            title: 'گالری',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گالری',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/show-place',
        name: 'showPlace',
        component: () => import("../views/News/ShowPlace"),
        meta: {
            title: 'رویدادها و نمایشگاه ها',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'رویدادها و نمایشگاه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/all-news',
        name: 'socialResponsibilities',
        component: () => import("../views/News/SocialResponsibilities"),
        meta: {
            title: 'ارشیو اخبار',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'ارشیو اخبار',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/management',
        name: 'management',
        component: () => import("../views/about/management/management"),
        meta: {
            title: 'مدیریت',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مدیریت و هیئت مدیره',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/FAQ',
        name: 'FAQ-page',
        component: () => import("../views/about/FAQ/FAQpage"),
        meta: {
            title: 'سوالات متداول',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'سوالات متداول',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import("../views/about/contactUs/ContactUs"),
        meta: {
            title: 'تماس با ما',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'تماس با ما',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/single/:id',
        name: 'single',
        component: () => import("../views/single/single"),
        // breadcrumbs:[
        //     {
        //         text: 'صفحه اصلی',
        //         disabled: false,
        //         href: '/',
        //       },
        //       {
        //         text: 'تماس با ما',
        //         disabled: true,
        //         href: '/',
        //       },
        // ]
    },
    {
        path: '/employment-form',
        name: 'employmentForm',
        component: () => import("../views/forms/EmploymentForm"),
        meta: {
            title: 'Employment Form',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'استخدام',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/suppliers-form',
        name: 'suppliersForm',
        component: () => import("../views/forms/SuppliersForm"),
        meta: {
            title: 'Suppliers Form',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'تامین کنندگان',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/suppliers-form-person',
        name: 'suppliersFormperson',
        component: () => import("../views/forms/SuppliersFormPerson"),
        meta: {
            title: 'Suppliers Form',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'تامین کنندگان',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/auctions-and-tenders',
        name: 'auctionsAndTenders',
        component: () => import("../views/auctionsAndTenders/auctionsAndTenders"),
        meta: {
            title: 'مزایده و مناقصه',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مزایده و مناقصه',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/auctions',
        name: 'auctions',
        component: () => import("../views/auctionsAndTenders/auctions"),
        meta: {
            title: 'مزایده',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مزایده',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/tenders',
        name: 'tenders',
        component: () => import("../views/auctionsAndTenders/tenders"),
        meta: {
            title: 'مناقصه',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مناقصه',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/inquiry',
        name: 'inquiry',
        component: () => import("../views/auctionsAndTenders/inquiry"),
        meta: {
            title: 'استعلام',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'استعلام',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/header',
        name: 'sageHeader',
        component: () => import("../views/sageHeader/sageHeader"),
        meta: {
            title: 'sageHeader'
        }
    },
    {
        path: '/sub/cement-block',
        name: 'cementBlock',
        component: () => import("../views/subdomain/cementBlock/cementBlock"),
        meta: {
            title: 'بلوک سیمانی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'بلوک سیمانی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass-fake',
        name: 'glass',
        component: () => import("../views/subdomain/glass-fake/glass"),
        meta: {
            title: 'شیشه'
        }
    },
    {
        path: '/sub/glasses',
        name: 'mainGlass',
        component: () => import("../views/subdomain/glass/mainGlass"),
        meta: {
            title: 'شیشه',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'شیشه فلوت',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material',
        name: 'material',
        component: () => import("../views/subdomain/material/material"),
        meta: {
            title: 'مواد اولیه',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مواد اولیه',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks',
        name: 'lightWeightBlocks',
        component: () => import("../views/subdomain/lightWeightBlocks/lightWeightBlocks"),
        meta: {
            title: 'بلوک سبک اتوکلاو شده',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'بلوک سبک اتوکلاو شده',
                    disabled: true,
                    href: '/',
                  },
            ]
        },
    },
    //light blocks
    {
        path: '/sub/light-blocks/construction/products',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/products/products"),
        meta: {
            title: 'محصولات',
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'ملات خشک و چسب های ساختمانی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/construction/product/:name',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/products/single"),
        meta: {
            title: 'محصول',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'محصول',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/about',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/AboutBase/AboutBase"),
        meta: {
            title: 'درباره ما',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'درباره ما',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/about/company',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/AboutCompany/AboutCompany"),
        meta: {
            title: 'درباره مجموعه',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'درباره مجموعه',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/about/management',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/AboutManagement/AboutManagement"),
        meta: {
            title: 'مدیرعامل',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مدیرعامل',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/about/export',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/AboutExport/AboutExport"),
        meta: {
            title: 'صادرات',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'صادرات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/technical',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/Technical/BaseTechnical"),
        meta: {
            title: 'اطلاعات فنی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اطلاعات فنی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/technical/build-structure',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/Technical/BuildStructure/BuildStructure"),
        meta: {
            title: 'نحوه اجرا',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'نحوه اجرا',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/technical/articles',
        name: 'blockArticles',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/Technical/articles/BlockArticles"),
        meta: {
            title: 'مقالات',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مقالات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/technical/catalogue',
        name: 'blockCatalogue',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/Technical/Catalogue/BlockCatalogue"),
        meta: {
            title: 'کاتالوگ',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'کاتالوگ',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/technical/certificates',
        name: 'blockCertificates',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/Technical/certificates/BlockCertificates"),
        meta: {
            title: 'گواهینامه ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گواهینامه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/technical/calculator',
        name: 'blockCalculator',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/Technical/Calculator/Calculator"),
        meta: {
            title: 'ماشین حساب',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'ماشین حساب',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/news',
        name: 'blockNews',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/subNews/blockNews"),
        meta: {
            title: 'اخبار',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخبار',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/projects',
        name: 'blockProjects',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/subNews/projects/BlockProjects"),
        meta: {
            title: 'پروژه ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'پروژه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/operation-network',
        name: 'operationNetwork',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/operationNetwork/operationNetwork"),
        meta: {
            title: 'شبکه عاملیت',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'شبکه عاملیت',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/operation-network',
        name: 'operationNetwork',
        component: () => import("../views/subdomain/material/pages/operationNetwork/operationNetwork"),
        meta: {
            title: 'شبکه عاملیت',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'شبکه عاملیت',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/representation',
        name: 'representation',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/operationNetwork/Representation/Representation"),
        meta: {
            title: 'شرایط اخذ نمایندگی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'شرایط اخذ نمایندگی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/agencies',
        name: 'agencies',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/operationNetwork/Maps"),
        meta: {
            title: 'اخذ نمایندگی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخذ نمایندگی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/agencies-form',
        name: 'agenciesForm',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/operationNetwork/AgenciesForm/AgenciesForm"),
        meta: {
            title: 'اخذ نمایندگی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخذ نمایندگی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/news/gallery',
        name: 'baseGallery',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/subNews/gallery/baseGallery"),
        meta: {
            title: 'گالری',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گالری',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/news/certificates',
        name: 'baseCertificates',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/Technical/certificates/BlockCertificates"),
        meta: {
            title: 'گواهینامه ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گواهینامه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/news/all-news',
        name: 'baseNews',
        component: ()=>import("../views/subdomain/lightWeightBlocks/pages/subNews/news/baseNews"),
        meta: {
            title: 'اخبار',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخبار',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/news/events',
        name: 'baseEvents',
        component: ()=>import("../views/subdomain/lightWeightBlocks/pages/subNews/events/baseEvents"),
        meta: {
            title: 'رویداد ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'رویدادها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/single/:id',
        name: 'single',
        component: () => import("../views/single/single"),

    },

    //material
    {
        path: '/sub/material/single/:id',
        name: 'material-single',
        component: () => import("../views/single/single"),

    },
    {
        path: '/sub/material/about',
        component: () => import('../views/subdomain/material/pages/About/AboutBase/AboutBase'),
        meta: {
            title: 'درباره ما',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'درباره ما',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/about/company',
        component: () => import('../views/subdomain/material/pages/About/AboutCompany/AboutCompany'),
        meta: {
            title: 'درباره مجموعه',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'درباره مجموعه',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/about/management',
        component: () => import('../views/subdomain/material/pages/About/AboutManagement/AboutManagement'),
        meta: {
            title: 'مدیرعامل',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مدیرعامل',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/about/export',
        component: () => import('../views/subdomain/material/pages/About/AboutExport/AboutExport'),
        meta: {
            title: 'صادرات',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'صادرات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/technical',
        component: () => import('../views/subdomain/material/pages/Technical/BaseTechnical'),
        meta: {
            title: 'اطلاعات فنی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اطلاعات فنی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/technical/articles',
        name: 'MaterialArticles',
        component: () => import('../views/subdomain/material/pages/Technical/articles/BlockArticles'),
        meta: {
            title: 'مقالات',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مقالات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/technical/catalogue',
        name: 'MaterialCatalogue',
        component: () => import('../views/subdomain/material/pages/Technical/Catalogue/BlockCatalogue'),
        meta: {
            title: 'کاتالوگ',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'کاتالوگ',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/technical/certificates',
        name: 'MaterialCertificates',
        component: () => import('../views/subdomain/material/pages/Technical/certificates/BlockCertificates'),
        meta: {
            title: 'گواهینامه ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گواهینامه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/news',
        name: 'MaterialNews',
        component: () => import('../views/subdomain/material/pages/subNews/blockNews'),
        meta: {
            title: 'اخبار',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخبار',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/projects',
        name: 'MaterialProjects',
        component: () => import('../views/subdomain/material/pages/subNews/projects/BlockProjects'),
        meta: {
            title: 'پروژه ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'پروژه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/news/gallery',
        name: 'baseMaterialGallery',
        component: () => import('../views/subdomain/material/pages/subNews/gallery/baseGallery'),
        meta: {
            title: 'گالری',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گالری',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/news/all-news',
        name: 'baseMaterialNews',
        component: () => import('../views/subdomain/material/pages/subNews/news/baseNews'),
        meta: {
            title: 'اخبار',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخبار',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/news/events',
        name: 'baseMaterialEvents',
        component: () => import('../views/subdomain/material/pages/subNews/events/baseEvents'),
        meta: {
            title: 'رویداد ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'رویدادها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    //glass
   /* {
        path: '/sub/glass/about',
        component: () => import('../views/subdomain/glass/pages/About/AboutBase/AboutBase'),
        meta: {
            title: 'درباره ما'
        }
    },
    {
        path: '/sub/glass/about/company',
        component: () => import('../views/subdomain/glass/pages/About/AboutCompany/AboutCompany'),
        meta: {
            title: 'درباره مجموعه'
        }
    },
    {
        path: '/sub/glass/about/management',
        component: () => import('../views/subdomain/glass/pages/About/AboutManagement/AboutManagement'),
        meta: {
            title: 'مدیرعامل'
        }
    },
    {
        path: '/sub/glass/about/export',
        component: () => import('../views/subdomain/glass/pages/About/AboutExport/AboutExport'),
        meta: {
            title: 'صادرات'
        }
    },*/

    {
        path: '/sub/glass/about',
        component: () => import("../views/subdomain/glass/pages/About/AboutBase/AboutBase"),
        meta: {
            title: 'درباره ما',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'درباره ما',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/about/company',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/AboutCompany/AboutCompany"),
        meta: {
            title: 'درباره مجموعه',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'درباره ما مجموعه',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/about/management',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/AboutManagement/AboutManagement"),
        meta: {
            title: 'مدیرعامل',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مدیرعامل',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/about/export',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/AboutExport/AboutExport"),
        meta: {
            title: 'صادرات',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'صادرات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },

    {
        path: '/sub/glass/technical',
        component: () => import('../views/subdomain/glass/pages/Technical/BaseTechnical'),
        meta: {
            title: 'اطلاعات فنی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اطلاعات فنی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/technical/articles',
        component: () => import('../views/subdomain/glass/pages/Technical/articles/BlockArticles'),
        meta: {
            title: 'مقالات',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'مقالات',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/technical/catalogue',
        component: () => import('../views/subdomain/glass/pages/Technical/Catalogue/BlockCatalogue'),
        meta: {
            title: 'کاتالوگ',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'کاتالوگ',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/technical/certificates',
        component: () => import('../views/subdomain/glass/pages/Technical/certificates/BlockCertificates'),
        meta: {
            title: 'گواهینامه ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گواهینامه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/news',
        component: () => import('../views/subdomain/glass/pages/subNews/blockNews'),
        meta: {
            title: 'اخبار',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخبار',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/projects',
        component: () => import('../views/subdomain/glass/pages/subNews/projects/BlockProjects'),
        meta: {
            title: 'پروژه ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'پروژه ها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/news/gallery',
        component: () => import('../views/subdomain/glass/pages/subNews/gallery/baseGallery'),
        meta: {
            title: 'گالری',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'گالری',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/news/all-news',
        component: () => import('../views/subdomain/glass/pages/subNews/news/baseNews'),
        meta: {
            title: 'اخبار',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخبار',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/single/:id',
        component: () => import('../views/single/single'),
        meta: {
            title: 'محصول',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'محصول',
                    disabled: true,
                    href: '/',
                  },
            ]
        },
        props:true
    },
    {
        path: '/sub/glass/news/events',
        component: () => import('../views/subdomain/glass/pages/subNews/events/baseEvents'),
        meta: {
            title: 'رویداد ها',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'رویدادها',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/operation-network',
        component: () => import("../views/subdomain/glass/pages/operationNetwork/operationNetwork"),
        meta: {
            title: 'شبکه عاملیت',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'شبکه عاملیت',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/representation',
        component: () => import("../views/subdomain/glass/pages/operationNetwork/Representation/Representation"),
        meta: {
            title: 'شرایط اخذ نمایندگی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'شرایط اخذ نمایندگی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/agencies',
        component: () => import("../views/subdomain/glass/pages/operationNetwork/Maps"),
        meta: {
            title: 'اخذ نمایندگی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخذ نمایندگی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/agencies-form',
        component: () => import("../views/subdomain/glass/pages/operationNetwork/AgenciesForm/AgenciesForm"),
        meta: {
            title: 'اخذ نمایندگی',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'اخذ نمایندگی',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/contact-us',
        component: () => import("../views/subdomain/glass/pages/About/ContactUs/ContactUs"),
        meta: {
            title: 'تماس با ما',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'تماس با ما',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/light-blocks/contact-us',
        component: () => import("../views/subdomain/lightWeightBlocks/pages/About/ContactUs/ContactUs"),
        meta: {
            title: 'تماس با ما',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'تماس با ما',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/material/contact-us',
        component: () => import("../views/subdomain/material/pages/About/ContactUs"),
        meta: {
            title: 'تماس با ما',
            
            breadcrumbs:[
                {
                    text: 'صفحه اصلی',
                    disabled: false,
                    href: '/',
                  },
                  {
                    text: 'تماس با ما',
                    disabled: true,
                    href: '/',
                  },
            ]
        }
    },
    {
        path: '/sub/glass/single/:id',
        name: 'single',
        component: () => import("../views/single/single"),
    },


]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: function(to, from, savedPosition) {
        if (to.hash) {
          return {selector: to.hash}
        } else {
          return {x: 0, y: 0}
        }
      },
})
router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/sign-in', '/register'];
    const authRequired = !publicPages.includes(to.path);

    // if (authRequired && !isAuthenticated()) {
    //     return next('/sign-in');
    // }
    // if (!authRequired && isAuthenticated()) {
    //     return next('/');
    // }


    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = i18n.tc(nearestWithTitle.meta.title);

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    // store.commit('settingManger/setLoading', true);
    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));
    return next();

});
export default router
